import React from "react";
import { useLocation } from "react-router-dom";
import { TwoStepBreadcrumb } from "../../components/CardContainer";
import { withEENavBar } from "../../components/EENavBar";
import { withRBAC } from "../../contexts/RBAC";
import { withRequireLogin } from "../../contexts/RequireLogin";
import {
  AssistedConfigWizard,
  AssistedWizardFormValues,
} from "./wizards/AssistedConfigWizard";

export const SEARCH_PARAM_PLATFORM = "platform";
export const SEARCH_PARAM_SECONDARY_PLATFORM = "secondaryPlatform";

export const NewConfigurationPageContent: React.FC = () => {
  const location = useLocation();

  // Check query parameters for initial form values
  const searchParams = new URLSearchParams(location.search);
  const initValues: Partial<AssistedWizardFormValues> = {
    platform: searchParams.get(SEARCH_PARAM_PLATFORM) ?? undefined,
    secondaryPlatform:
      searchParams.get(SEARCH_PARAM_SECONDARY_PLATFORM) ?? undefined,
  };

  return (
    <>
      <TwoStepBreadcrumb
        navLink="/configurations"
        navLabel="Configurations"
        current="New"
        spacing="short"
      />
      <AssistedConfigWizard initValues={initValues} />
    </>
  );
};

export const NewConfigurationPage: React.FC = withRequireLogin(
  withRBAC(withEENavBar(NewConfigurationPageContent)),
);
